import { render, staticRenderFns } from "./orderHoldBar.vue?vue&type=template&id=38ce77e0&"
import script from "./orderHoldBar.vue?vue&type=script&lang=js&"
export * from "./orderHoldBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports